import React, { Component } from 'react'
import axios from 'axios';
import {axiosEH} from './common/functions'
const Joi = require('joi');

class Signup extends Component {
  // 1. 1st-level vars
  constructor() {
    super()
    this.state = {
      username: '',
      password: '',
      email: '',
      isTeacher: true,
      teachername: '',
      classname: '',
      firstLanguage: 'English',
      languageList: [],
      statusMsg: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.hcCheckbox = this.hcCheckbox.bind(this)
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value.trim()
    })
  }

  hcCheckbox() {
    this.setState({ isTeacher: !this.state.isTeacher });
  }

  handleSubmit(event) {
    event.preventDefault();
    const minLen = parseInt(process.env.REACT_APP_USER_INP_MIN_LEN);
    const username = this.state.username;
    const password = this.state.password;
    const email = this.state.email;
    const teachername = this.state.teachername;
    const classname = this.state.classname;
    //console.log(this.state);

    const schema = Joi.object().keys({
      username: Joi.string().min(minLen).required().regex(/[-]/, { invert: true }),
      password: Joi.string().min(minLen).required(),
      email: Joi.string().email({ tlds: { allow: false } }).min(minLen).required(),
      teachername: Joi.string().min(minLen),
      classname: Joi.string(),
    });

    let dataToVal;
    if (this.state.isTeacher) {
      dataToVal = { username, password, email };      
    } else {
      dataToVal = { username, password, email, teachername, classname };      
    }
    const ret = schema.validate(dataToVal);
    const { error, value } = ret;
    if (error) {
      var arr = error.details;
      const msg = arr[0];
      this.setState({ statusMsg: String(msg.message) });
      return;
    }

    axios.post(process.env.REACT_APP_BASEURL + '/username/signup', {
      username: this.state.username,
      password: this.state.password,
      email: this.state.email,
      isTeacher: this.state.isTeacher,
      teachername: this.state.teachername,
      classname: this.state.classname,
      firstLanguage: this.state.firstLanguage,
    })
      .then(res => {	// {info: msg}
        this.setState({ statusMsg: String(res.data.info) });
        sessionStorage.removeItem('classList');
      })
      .catch(err => { 
        this.setState({ statusMsg: String(axiosEH(err)) });
      })
  }

  componentDidMount() {
    let objArr = [];
    const languageArr = process.env.REACT_APP_LANGUAGES.split("+");

    if (languageArr.length >0) {
      for (let i=0; i< languageArr.length; i++ ){
        objArr.push({firstLanguage: languageArr[i]})
      }
      this.setState(() => {
        return {
          languageList: objArr.map(e=> e.firstLanguage)
        }
      })
    }
  }
  // end of f()

  render() {
    return (
      <section className="signup-form is-medium mx-5" style={{ maxWidth: "100%" }} >
        <input className="input is-danger"  type="text" name="username"
          placeholder="Username (4+ letters)"
          value={this.state.username.trim()}
          maxLength={process.env.REACT_APP_USER_INP_MAX_LEN}
          onChange={this.handleChange}>
        </input>

        <input className="input is-danger" type="password" name="password" placeholder="Password (4+ letters)"
          value={this.state.password.trim()}
          maxLength={process.env.REACT_APP_USER_INP_MAX_LEN}
          onChange={this.handleChange}>
        </input>

        <input className="input is-danger" type="text" name="email"
          placeholder="Email (to receive report)"
          value={this.state.email.trim()}
          maxLength={process.env.REACT_APP_USER_INP_MAX_LEN}
          onChange={this.handleChange}>
        </input>

        <div className="select" style={{width:'80%'}}>
            <select name='firstLanguage' onChange={this.handleChange} >
                <option >Flashcard translation languages</option>
                {this.state.languageList.map((option, index) => {          
                    return (
                        <option key={index}>
                            {option}
                        </option>
                    );
                })}
            </select>
        </div>

        { this.state.firstLanguage == "simplified-Chinese" && <label className="label">
          <input type="checkbox"
            value={this.state.isTeacher}
            onChange={this.hcCheckbox}>
          </input>
        Sign up as a student</label> }
        
        {!this.state.isTeacher && <input className="input is-danger" type="text" name="teachername"
        placeholder="Teachername"
        value={this.state.teachername.trim()}
        maxLength={process.env.REACT_APP_USER_INP_MAX_LEN}
        onChange={this.handleChange}>
        </input> }

        {!this.state.isTeacher && <input className="input is-danger" type="text" name="classname"
        placeholder="Classname"
        value={this.state.classname.trim()}
        maxLength={process.env.REACT_APP_USER_INP_MAX_LEN}
        onChange={this.handleChange}>
        </input> } <br></br>

        <button className="button is-success"
          onClick={this.handleSubmit}
          type="submit" >Signup
        </button>

        <br></br> <br></br>
        <label className="label has-text-success">{this.state.statusMsg}</label>
      </section>
    )
  }
}

export default Signup